import { render, staticRenderFns } from "./AuthenticationHeader.vue?vue&type=template&id=dc838fd2&scoped=true"
import script from "./AuthenticationHeader.vue?vue&type=script&lang=js"
export * from "./AuthenticationHeader.vue?vue&type=script&lang=js"
import style0 from "./AuthenticationHeader.vue?vue&type=style&index=0&id=dc838fd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc838fd2",
  null
  
)

export default component.exports